(() => {
  const slugify = (value) => value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 72);

  const initArticle = (root) => {
    const content = root.querySelector('[data-ssa-content]');
    const toc = root.querySelector('[data-ssa-toc]');
    const list = root.querySelector('[data-ssa-toc-list]');
    const aside = root.querySelector('[data-ssa-aside]');
    const layout = root.querySelector('[data-ssa-layout]');

    if (!content || !toc || !list) return;

    const headings = [...content.querySelectorAll('h2, h3')]
      .filter((heading) => heading.textContent.trim().length > 0);

    if (headings.length < 2) {
      toc.hidden = true;
      if (aside && !aside.querySelector('.ssa-side-cta')) {
        aside.hidden = true;
        layout?.classList.add('ssa-layout--single');
      }
      return;
    }

    const used = new Set();
    headings.forEach((heading, index) => {
      let id = heading.id || slugify(heading.textContent) || `section-${index + 1}`;
      const base = id;
      let suffix = 2;
      while (used.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) {
        id = `${base}-${suffix++}`;
      }
      used.add(id);
      heading.id = id;

      const item = document.createElement('li');
      if (heading.tagName === 'H3') item.className = 'is-sub';
      const link = document.createElement('a');
      link.href = `#${id}`;
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      list.appendChild(item);
    });

    if (!('IntersectionObserver' in window)) return;
    const links = [...list.querySelectorAll('a')];
    const setActive = (id) => {
      links.forEach((link) => {
        const active = link.getAttribute('href') === `#${id}`;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    };

    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible[0]) setActive(visible[0].target.id);
    }, { rootMargin: '-20% 0px -68% 0px', threshold: 0 });

    headings.forEach((heading) => observer.observe(heading));
  };

  const init = () => document.querySelectorAll('[data-ssa]').forEach(initArticle);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
